import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Box from '@mui/material/Box';
import Layout from './components/Layout/Layout';
import HeroSection from './components/Home/HeroSection';
import HighlightsSection from './components/Home/HighlightsSection';
import SkillsSection from './components/Home/SkillsSection';
import CVPage from './components/CV/CVPage';
import NewsFeed from './components/News/NewsFeed';
import NewsArticlePage from './components/News/NewsArticle';
import NotFoundPage from './components/NotFound/NotFoundPage';

const HomePage: React.FC = () => (
    <Box>
        <HeroSection />
        <HighlightsSection />
        <SkillsSection />
    </Box>
);

const App: React.FC = () => (
    <ThemeProvider>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<HomePage />} />
                    <Route path="cv" element={<CVPage />} />
                    <Route path="news" element={<NewsFeed />} />
                    <Route path="news/:newsId" element={<NewsArticlePage />} />
                    <Route path="404" element={<NotFoundPage />} />
                    <Route path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    </ThemeProvider>
);

export default App;
